export default __webpack_public_path__ + "83435084dc28f99c307a27da43c28109.png";